import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  InjectionToken,
  Input,
  Optional,
} from '@angular/core';
import { Renderable, RenderableConfig } from '../app.models';

export const PARAGRAPH_TOKEN = new InjectionToken<ParagraphConfig>(
  'to content data into paragraph component'
);

export interface ParagraphConfig extends RenderableConfig {
  text?: string;
}

@Component({
    selector: 'app-paragraph',
    templateUrl: './paragraph.component.html',
    styleUrls: ['./paragraph.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ParagraphComponent implements Renderable {
  private _config!: ParagraphConfig;
  @Input() public set config(config: ParagraphConfig) {
    this._config = config;
  }
  public get config() {
    return this._config;
  }

  constructor(
    @Optional()
    @Inject(PARAGRAPH_TOKEN)
    private _injectedConfig: ParagraphConfig
  ) {
    this._config = this._injectedConfig;
  }
}
